// extracted by mini-css-extract-plugin
module.exports = {"container":"Tip_container__1CKjM","title":"Tip_title__2W678","desc":"Tip_desc__3oij5"};